import * as Yup from 'yup';
import { isValidNip } from '../../helpers/validation';
import { sharedSchema } from '../shared/sharedSchema';

export const schema = Yup.object().shape({
    employerCompanyName: Yup.string().when('workerType', {
        is: 'Pracownik w firmie zagranicznej',
        then: Yup.string().required('Pole wymagane'),
    }),
    nip: Yup.string().when('workerType', {
        is: 'Pracownik - osoba cywilna',
        then: Yup.string()
            .required('Pole wymagane')
            .test('nip', 'Nieprawidłowy NIP', (value) => isValidNip(value)),
    }),
    // dateOfIllness: Yup.string().required('Pole wymagane').nullable(),
    // dateOfBackToWork: Yup.string().required('Pole wymagane').nullable(),
    importantInformation: Yup.string().required('Pole wymagane'),
    workerType: Yup.string().required('Pole wymagane'),
    ...sharedSchema,
});
